<template>
  <div class="float-right">
    <button-group v-for="group in buttonGroups" :p-button-group="group" :key="group.key"></button-group>
    <select-group v-for="select in selectGroups" :p-select-group="select" :key="select.key"></select-group>
    <search-group v-for="search in searchGroups" :p-search-group="search" :key="search.key"></search-group>
    <!-- <simple-search 
      :p-button-groups="buttonGroups" 
      :p-search-groups="searchGroups"
      :p-selects="selects"
      ></simple-search> -->
  </div>
</template>
 

<script>
import OrderMixin from '@/mixins/order'
import {getUser} from '@/services/auth'
import ButtonGroup from '@/components/_partial/ButtonGroup'
import SearchGroup from '@/components/_partial/SearchGroup'
import SelectGroup from '@/components/_partial/SelectGroup'

function computeSearchGroups () {
  // searchGroups
  let searchGroup = {}
  searchGroup.key = 'company_order_no'
  searchGroup.name = '外部订单号'
  searchGroup.value = ''
  searchGroup.menus = [
    { key: 'company_order_no', name: '外部订单号' },
    { key: 'order_no', name: '内部订单号' },
    { key: 'product_code', name: '产品代码' },
    { key: 'ship_no', name: '快递号' },
    { key: 'consignee_phone', name: '手机号' },
    { key: 'consignee_name', name: '收件人' }
  ]
  return [searchGroup]
}

function computeSelects () {
  let selects = []
  selects.push({
    name: '顺序排列',
    value: false,
    key: 'ordering',
    internalValue: 'downloaded_at'
  })

  return selects
}

export default {
  name: 'orders-search',
  components: {
    ButtonGroup,
    SearchGroup,
    SelectGroup
  },
  mixins: [OrderMixin],
  methods: {
    getUser,
    computeSearchGroups,
    computeSelects
  },
  computed: {
    buttonGroups () {
      return [
        this.computeOrderStatusGroup(),
        this.computeCompanyButtonGroup(),
        this.computeShipCompanyButtonGroup()
      ]
    },
    searchGroups () { return this.computeSearchGroups() },
    selectGroups () { return this.computeSelects() }
  }
}
</script>
